import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import BrandLogo from '../BrandLogo';

/**
 * AuthLayout component for unauthenticated pages
 * Provides a clean, centered layout for authentication screens with gradient background
 */
const AuthLayout = () => {
  return (
    <div className="sm-marketing sm-app-bg min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1><Link to="/" aria-label="SageMindLabs home" className="inline-block rounded-lg"><BrandLogo /></Link></h1>
            <p className="text-gray-400 mt-2">Grounded answers from your knowledge base</p>
          </div>
          <Outlet />
        </div>
      </div>
      <footer className="py-4 text-center text-sm text-gray-500">
        <p>© {new Date().getFullYear()} SageMindLabs. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AuthLayout;
